/**
 * Build an identifiable review fingerprint
 */
import { IToolboxReview } from '../../types/interfaces';

/**  Environment  */
import { environmentVariables } from '../util';
environmentVariables();

/**  Exports  */
export default function reviewFingerprint(review: IToolboxReview): string {
    const { network: input_network, content, created_at, rating, author } = review;

    const network = input_network === 'google-rsv' ? 'google' : input_network;

    //  Date
    const date = new Date(created_at);
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());

    const month = date.getMonth() + 1;
    const m = month < 10 ? `0${month}` : month.toString();
    const datestring = `${date.getFullYear()}-${m}`;

    /**
     * Return
     */
    const content_trimmed =
        content &&
        content
            .replace(/\W/g, '')
            .toLowerCase()
            .substr(0, 100);

    //  A: No content? Use author, rating
    if (!content_trimmed) {
        const author_name = `${author?.first_name || ''} ${author?.last_name || ''}`
            .replace(/\W/g, '')
            .toLowerCase()
            .trim();

        return `${network}-${datestring}-${rating}-${author_name}`;
    }

    //  B: Content informs fingerprint
    return content_trimmed.length > 40
        ? `${network}-${content_trimmed}`
        : `${network}-${datestring}-${content_trimmed}`;
}
